import type { TOC } from '@ember/component/template-only';

interface GeneralDropdownsDropdownArrowButtonSignature {
  Args: {
    isDisabled?: boolean;
    isOpen?: boolean;
  };
  Element: HTMLDivElement;
}

const GeneralDropdownsDropdownArrowButton = <template>
  <div
    class="btn btn-arrow {{if @isDisabled 'disabled'}}"
    role="button"
    ...attributes
  >
    <div class="arrow {{if @isOpen 'open'}}"></div>
  </div>
</template> satisfies TOC<GeneralDropdownsDropdownArrowButtonSignature>;

export default GeneralDropdownsDropdownArrowButton;
